import {
  JSXElementConstructor,
  ReactElement,
  ReactNode,
  useState,
} from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Modal,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import { ApplicationById } from "../../types/General";
const IMAGE_MEDIA_TYPES = ["image/png", "image/jpg", "image/jpeg", "image/svg"];

const isImage = (mediaType: string) => IMAGE_MEDIA_TYPES.includes(mediaType);
const ApplicationDocuments = ({
  details,
}: {
  details: ApplicationById | null;
}) => {
  const [open, setOpen] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState<any>(null);

  if (!details) return <Typography>No documents found</Typography>;

  const handleOpen = (doc: any) => {
    if (isImage(doc?.media_type)) {
      setSelectedDoc(doc);
      setOpen(true);
    } else {
      window.open(doc?.media_url);
    }
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedDoc(null);
  };

  const renderDocuments = (
    documents: any[],
    title:
      | string
      | number
      | boolean
      | ReactElement<any, string | JSXElementConstructor<any>>
      | Iterable<ReactNode>
      | null
      | undefined
  ) => {
    if (!documents || documents?.length === 0) return null;

    return (
      <Box>
        <Typography variant="h6" sx={{ marginBottom: 2, fontWeight: "bold" }}>
          {title}
        </Typography>
        {documents?.map((doc) => (
          <Card
            key={doc.id}
            sx={{
              marginBottom: 2,
              display: "flex",
              alignItems: "center",
              padding: 1,
            }}
          >
            <CardContent
              sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}
            >
              <img
                src={
                  isImage(doc.media_type)
                    ? doc.media_url
                    : "/static/images/pdf.png"
                }
                alt={doc.media_name || "Document"}
                style={{
                  width: 90,
                  height: 70,
                  marginRight: 10,
                  objectFit: "contain",
                  border: "1px solid lightgray",
                  borderRadius: "10px",
                }}
              />
            </CardContent>
            <IconButton onClick={() => handleOpen(doc)}>
              <VisibilityIcon />
            </IconButton>
          </Card>
        ))}
      </Box>
    );
  };

  const renderDocumentsWithName = (documents: any[]) => {
    if (!documents || documents.length === 0) return null;

    return (
      <Box>
        {documents.map((doc) => (
          <Box key={doc.id} sx={{ marginBottom: 2 }}>
            {doc.name && (
              <Typography
                variant="h6"
                sx={{ marginBottom: 1, fontWeight: "bold" }}
              >
                {doc.name}
              </Typography>
            )}
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: 1,
              }}
            >
              <CardContent
                sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}
              >
                <img
                  src={
                    doc.media_url?.endsWith(".pdf")
                      ? "/static/images/pdf.png"
                      : doc.media_url
                  }
                  alt={doc.media_name || "Document"}
                  style={{
                    width: 90,
                    height: 70,
                    marginRight: 10,
                    objectFit: "contain",
                    border: "1px solid lightgray",
                    borderRadius: "10px",
                  }}
                />
              </CardContent>
              <IconButton onClick={() => handleOpen(doc)}>
                <VisibilityIcon />
              </IconButton>
            </Card>
          </Box>
        ))}
      </Box>
    );
  };

  const hasDocuments =
    (details?.contract_proof && details.contract_proof.length > 0) ||
    (details?.extra_documents && details.extra_documents.length > 0);

  return (
    <Box>
      {details?.passport_proof?.length > 0 ? (
        <>{renderDocuments(details?.passport_proof, "Passport Proof")}</>
      ) : null}
      {details?.contract_proof?.length > 0 ? (
        <>
          {renderDocuments(
            details?.contract_proof,
            "Contract Scanned Document"
          )}
        </>
      ) : null}
      {details?.identity_proof?.length > 0 ? (
        <>{renderDocuments(details?.identity_proof, "Identity Proof")}</>
      ) : null}
      {details?.school_cert?.length > 0 ? (
        <>{renderDocuments(details?.school_cert, "School Certificate")}</>
      ) : null}
      {details?.state_exam_cert?.length > 0 ? (
        <>
          {renderDocuments(details?.state_exam_cert, "University Certificate")}
        </>
      ) : null}

      {details?.extra_documents?.length > 0 &&
        renderDocumentsWithName(details?.extra_documents)}

      {!hasDocuments && <Typography>No documents found</Typography>}

      {/* Modal for preview */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            position: "relative",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 20,
              right: 20,
              background: "white",
            }}
          >
            <CloseIcon />
          </IconButton>
          {selectedDoc && (
            <img
              src={selectedDoc.media_url}
              alt={selectedDoc.media_name}
              style={{ maxWidth: "90%", maxHeight: "90%" }}
            />
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default ApplicationDocuments;
